module.exports = __webpack_public_path__ + "img/ic_tripadvisor-0.0.981c0f91.svg";